import axios from './../../config/axios';

function search(query) {
    return axios().get("/purchase/dimensions-search", { params: { search: query } })
}

export default {
    search
}